import { render } from "./ProductEditModal.vue?vue&type=template&id=f807f60c"
import script from "./ProductEditModal.vue?vue&type=script&lang=js"
export * from "./ProductEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__